import { RefComponentBase, Ref, ListItem, Link } from "@tblabs/truffle";


export class TabsSwitcher extends RefComponentBase<string, HTMLUListElement>
{
    protected switches = {};

    constructor(ref: Ref<string>)
    {
        super("ul", ref);
        this.Attribute("uk-tab");
        this.Class("uk-tab");
    }

    public Refresh(): void
    {
        this.switches.Keys().forEach(activator =>
        {
            const cmp = this.switches[activator];

            if (this.ref.value === activator)
                cmp.AddClass("uk-active");

            else
                cmp.RemoveClass("uk-active");
        });
    }

    public Add(label: string)
    {
        const item = new ListItem(new Link(label, "#"));
        this.switches[label] = item;

        item.OnClick(() => this.ref.value = label);

        if (this.ref.value == label)
            item.AddClass("uk-active");

        if (this.ref.value == "")
            this.ref.value = label;

        this.Append(item);

        return this;
    }
}
